import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ThemeProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadTheme();
  }, []);

  const loadTheme = async () => {
    try {
      const res = await axios.get(`${API}/theme`);
      const colors = res.data;
      
      // Apply CSS variables to :root
      const root = document.documentElement;
      
      root.style.setProperty('--bg-primary', colors.bg_primary);
      root.style.setProperty('--bg-secondary', colors.bg_secondary);
      root.style.setProperty('--bg-card', colors.bg_card);
      root.style.setProperty('--bg-card-hover', colors.bg_card_hover);
      root.style.setProperty('--text-primary', colors.text_primary);
      root.style.setProperty('--text-secondary', colors.text_secondary);
      root.style.setProperty('--text-muted', colors.text_muted);
      root.style.setProperty('--accent-primary', colors.accent_primary);
      root.style.setProperty('--accent-secondary', colors.accent_secondary);
      root.style.setProperty('--accent-danger', colors.accent_danger);
      root.style.setProperty('--cta-bg', colors.cta_bg);
      root.style.setProperty('--cta-bg-hover', colors.cta_bg_hover);
      root.style.setProperty('--cta-text', colors.cta_text);
      root.style.setProperty('--border-color', colors.border_color);
      root.style.setProperty('--border-hover', colors.border_hover);
      root.style.setProperty('--badge-bg', colors.badge_bg);
      root.style.setProperty('--badge-text', colors.badge_text);
      root.style.setProperty('--header-bg', colors.header_bg);
      root.style.setProperty('--modal-overlay', colors.modal_overlay);
      
    } catch (error) {
      console.error("Error loading theme:", error);
    } finally {
      setLoaded(true);
    }
  };

  if (!loaded) {
    return null; // Or a loading spinner
  }

  return children;
};

export default ThemeProvider;
